module.exports = __webpack_public_path__ + "img/mobile scanner stand51.58821707.jpg";